import { Box, Link, Typography } from "@mui/material";
import { useEffect } from "react";

interface InstagramFeedProps {
    username: string;
}

const EMBED_SCRIPT_SRC = "//www.instagram.com/embed.js";

declare global {
    interface Window {
        instgrm?: { Embeds?: { process: () => void } };
    }
}

const InstagramFeed = ({ username }: InstagramFeedProps) => {
    const profileUrl = `https://www.instagram.com/${username}/`;

    useEffect(() => {
        const existing = document.querySelector<HTMLScriptElement>(`script[src="${EMBED_SCRIPT_SRC}"]`);
        if (existing) {
            window.instgrm?.Embeds?.process();
            return;
        }
        const script = document.createElement("script");
        script.src = EMBED_SCRIPT_SRC;
        script.async = true;
        document.body.appendChild(script);
    }, [username]);

    return (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
            <blockquote
                className="instagram-media"
                data-instgrm-permalink={profileUrl}
                data-instgrm-version="14"
                style={{
                    background: "#FFF",
                    border: 0,
                    borderRadius: 3,
                    boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)",
                    margin: 1,
                    maxWidth: 540,
                    padding: 0,
                    width: "calc(100% - 2px)",
                }}
            >
                <Typography variant="body1" align="center" sx={{ p: 2 }}>
                    <Link href={profileUrl} target="_blank" rel="noopener noreferrer">
                        View @{username} on Instagram
                    </Link>
                </Typography>
            </blockquote>
        </Box>
    );
};

export default InstagramFeed;
